import JsBarcode from "jsbarcode";
import moment from "moment";
import { beToAd, formatDate } from "react-lib/utils/dateUtils";
import {
  HeaderLogoWithTitleContent,
  HeaderLogoWithAddress,
} from "../HISV3/common/HeaderPdfFormTemplate";
import CONFIG from "config/config";

import { getDataURLFromURL } from "react-lib/apps/HISV3/common/CommonInterface";

const FORM_NAME = "FormAppointmentDetail";

const textToBase64BarcodeBlob = (text: string) => {
  const canvas = document.createElement("canvas");
  JsBarcode(canvas, text, { displayValue: false });
  return canvas.toDataURL("image/png");
};

const FormAppointmentDetail = async (props: any) => {
  console.log("FormAppointmentDetail props.data:", props.data);

  const [divisionQR] = await getDataURLFromURL([{ image: props.data.divisionQR }]);

  // issue 65040 Header CU กับ Sapiens ใช้ไม่เหมือนกัน
  const headerForm =
    CONFIG.COMPANY === "SAPIENS"
      ? await HeaderLogoWithAddress({
          form: FORM_NAME,
          font: "THSarabunNew",
          logoHeight: 30,
          pageMargins: [10, 110, 10, CONFIG.HIDE_APPOINTMENT_BARCODE ? 25 : 55],
          headerMargins: [10, 5, 10, 5],
          styles: {
            facultyHeader: {
              fontSize: 20,
              bold: true,
            },
            fieldKey: {
              bold: true,
              fontSize: 15,
            },
            fieldValue: {
              fontSize: 15,
            },
            miniFieldKey: {
              bold: true,
              fontSize: 12.5,
            },
            miniFieldValue: {
              fontSize: 13,
            },
          },
          titleContent: [
            {
              text: props.data?.language === "EN" ? "Appointment" : "ใบนัดหมาย",
              style: "facultyHeader",
              alignment: "center",
            },
          ],
        })
      : await HeaderLogoWithTitleContent({
          form: FORM_NAME,
          font: "THSarabunNew",
          logoHeight: 40,
          logoPosition: { x: 10, y: 8 },
          pageMargins: [10, 60, 10, 75],
          titleMargins: [80, 3, 0, 0],
          headerMargins: [10, 5, 10, 5],
          styles: {
            facultyHeader: {
              fontSize: 20,
              bold: true,
            },
            fieldKey: {
              bold: true,
              fontSize: 15,
            },
            fieldValue: {
              fontSize: 15,
            },
            miniFieldKey: {
              bold: true,
              fontSize: 12.5,
            },
            miniFieldValue: {
              fontSize: 13,
            },
          },
          titleName:
            props.data?.language === "EN"
              ? "Faculty of Dentistry Chulalongkorn University"
              : `โรงพยาบาลคณะทันตแพทยศาสตร์ จุฬาลงกรณ์มหาวิทยาลัย`,
          titleContent: [
            {
              text: props.data?.language === "EN" ? "Appointment" : "ใบนัดหมาย",
              style: "facultyHeader",
              alignment: "center",
            },
          ],
        });
  const { font, images, styles } = headerForm;

  const doctorData = () => {
    let doctorName = [
      {
        width: "14.5%",
        text: props.data?.language === "EN" ? "Doctor" : "แพทย์",
        style: "fieldKey",
      },
      { width: "4%", text: ":", style: "fieldValue" },
      {
        width: "42%",
        text:
          props.data?.language === "EN" && props.data?.doctorEN.trim() !== ""
            ? props.data?.doctorEN
            : props.data?.doctorTH,
        style: "fieldValue",
      },
    ];

    if (CONFIG.SHOW_DOCTOR_CHAIR) {
      doctorName.push(
        {
          width: "8%",
          text: props.data?.language === "EN" ? "Chair" : "เก้าอี้",
          style: "fieldKey",
        },
        { width: "4%", text: ":", style: "fieldValue" },
        {
          width: "21%",
          text:
            props.data?.extra?.chair === "" || props.data?.extra?.chair === "ว่าง"
              ? "-"
              : props.data?.extra?.chair || "-",
          style: "fieldValue",
        }
      );
    }

    return doctorName;
  };

  const contentHeader = () => {
    return [
      {
        columns: [
          {
            width: "14.5%",
            text: props.data?.language === "EN" ? "Clinic" : "คลินิก",
            style: "fieldKey",
          },
          { width: "4%", text: ":", style: "fieldValue" },
          {
            width: "*",
            text:
              props.data?.language === "EN"
                ? props.data?.divisionEN || props.data?.division_name
                : props.data?.division_name,
            style: "fieldValue",
          },
        ],
      },
      {
        text:
          props.data?.language === "EN"
            ? `Please contact staff at ${props.data?.divisionDetailEN}`
            : `ติดต่อ ${props.data?.divisionDetail}`,
        style: "fieldValue",
      },
      {
        columns: [
          {
            width: "14.5%",
            text: props.data?.language === "EN" ? "Patient Name" : "ชื่อ-นามสกุล",
            style: "fieldKey",
          },
          { width: "4%", text: ":", style: "fieldValue" },
          {
            width: "42%",
            text:
              props.data?.language === "EN"
                ? props.data?.fullNameEN || props.data?.full_name || ""
                : props.data?.full_name || "",
            style: "fieldValue",
          },
        ],
      },
      {
        columns: [
          { width: "14.5%", text: "HN", style: "fieldKey" },
          { width: "4%", text: ":", style: "fieldValue" },
          { width: "42%", text: props.data?.patient_hn || "", style: "fieldValue" },
          {
            width: "5%",
            text: props.data?.language === "EN" ? "Age" : "อายุ",
            style: "fieldKey",
          },
          { width: "4%", text: ":", style: "fieldValue" },
          {
            width: "*",
            text:
              props.data?.language === "EN"
                ? props.data?.fullAgeEN || ""
                : props.data?.full_age || "",
            style: "fieldValue",
          },
        ],
      },
      {
        columns: contentId(),
      },
      {
        margin: [0, 5, 0, 0],
        columns: [
          {
            width: "14.5%",
            text: props.data?.language === "EN" ? "Appoint Date" : "วันที่นัด",
            style: "fieldKey",
          },
          { width: "4%", text: ":", style: "fieldValue" },
          {
            width: "42%",
            text: props.data?.date
              ? props.data?.language === "EN"
                ? `${moment(props.data?.date, "DD/MM/YYYY").format("MMMM D")}, ${
                    Number(moment(props.data.date, "DD/MM/YYYY").format("YYYY")) - 543
                  }`
                : `${beToAd(props.data.date)
                    ?.clone()
                    .locale("th")
                    ?.format("วันdddd ที่ DD MMMM")} ${moment(props.data.date, "DD/MM/YYYY").format(
                    "YYYY"
                  )}`
              : "",
            style: "fieldValue",
          },
          {
            width: props.data?.language === "EN" ? "14%" : "8%",
            text: props.data?.language === "EN" ? "Appoint Time" : "เวลานัด",
            style: "fieldKey",
          },
          { width: "4%", text: ":", style: "fieldValue" },
          {
            width: props.data?.language === "EN" ? "15%" : "21%",
            text: props.data.appointment_time
              ? `${props.data.appointment_time} ${props.data?.language === "TH" ? "น." : ""}`
              : `${props.data.start || ""} - ${props.data.end || ""} ${
                  props.data?.language === "TH" ? "น." : ""
                }`,
            style: "fieldValue",
          },
        ],
      },
      {
        margin: [0, 5, 0, 0],
        columns: doctorData(),
      },
    ];
  };

  const appointmentDetail = () => {
    if ((props.data.doctor_note || []).length === 0) {
      if (CONFIG.SHOW_DOCTOR_CHAIR) {
        return [
          ...contentHeader(),
          {
            margin: [0, 5, 0, 0],
            columns: [
              {
                width: "14.5%",
                text: props.data?.language === "EN" ? "Objective" : "นัดเพื่อ",
                style: "fieldKey",
              },
              { width: "4%", text: ":", style: "fieldValue" },
              {
                width: "*",
                text: props.data?.extra?.appointmentFor || "-",
                style: "fieldValue",
              },
            ],
          },
        ];
      } else {
        return contentHeader();
      }
    } else {
      const noteLength = props.data.doctor_note.length;
      const appointmentLines = Math.round((props.data?.extra?.appointmentFor?.length || 0) / 60);
      const doctorNoteShow = appointmentLines > 5 ? 0 : 4 - appointmentLines;

      let detail: any[] = [];
      let cloneData = [...props.data.doctor_note];

      for (let i = 0; i < noteLength; i++) {
        if (i === 0) {
          let doctorNote = (cloneData || [])
            .splice(i, i + (CONFIG.SHOW_DOCTOR_CHAIR ? doctorNoteShow : 5))
            .map((note: string, index: number) => ({
              text: note || "",
              style: "miniFieldValue",
            }));

          const appointmentForColumn = [
            {
              margin: [0, 5, 0, 0],
              columns: [
                {
                  width: "14.5%",
                  text: props.data?.language === "EN" ? "Objective" : "นัดเพื่อ",
                  style: "fieldKey",
                },
                { width: "4%", text: ":", style: "fieldValue" },
                {
                  width: "*",
                  text: props.data?.extra?.appointmentFor || "-",
                  style: "fieldValue",
                },
              ],
            },
          ];

          const doctorNoteColumn = {
            margin: [0, 5, 0, 0],
            stack: [
              {
                text: props.data?.language === "EN" ? "Suggestion" : "คำแนะนำ",
                style: "fieldKey",
              },
              {
                margin: [5.5, 0, 0, 0],
                ul: doctorNote,
              },
            ],
          };

          const headerDetail = () => {
            if (!CONFIG.SHOW_DOCTOR_CHAIR) {
              return [doctorNoteColumn];
            } else {
              return doctorNoteShow === 0
                ? appointmentForColumn
                : [...appointmentForColumn, doctorNoteColumn];
            }
          };

          detail.push([...contentHeader(), ...headerDetail()]);

          i = i + ((CONFIG.SHOW_DOCTOR_CHAIR ? 3 : 5) - 1);
        } else {
          let doctorNote = (cloneData || []).splice(0, 10).map((note: string) => ({
            text: note || "",
            style: "miniFieldValue",
          }));

          detail.push([
            {
              pageBreak: "before",
              columns: [
                {
                  width: "14.5%",
                  text: props.data?.language === "EN" ? "Patient Name" : "ชื่อ-นามสกุล",
                  style: "fieldKey",
                },
                { width: "4%", text: ":", style: "fieldValue" },
                {
                  width: "42%",
                  text:
                    props.data?.language === "EN"
                      ? props.data?.fullNameEN || ""
                      : props.data?.full_name || "",
                  style: "fieldValue",
                },
              ],
            },
            {
              columns: [
                { width: "14.5%", text: "HN", style: "fieldKey" },
                { width: "4%", text: ":", style: "fieldValue" },
                { width: "42%", text: props.data?.patient_hn || "", style: "fieldValue" },
                {
                  width: "5%",
                  text: props.data?.language === "EN" ? "Age" : "อายุ",
                  style: "fieldKey",
                },
                { width: "4%", text: ":", style: "fieldValue" },
                {
                  width: "*",
                  text:
                    props.data?.language === "EN"
                      ? props.data?.fullAgeEN || ""
                      : props.data?.full_age || "",
                  style: "fieldValue",
                },
              ],
            },
            {
              margin: [0, 5, 0, 0],
              stack: [
                {
                  text: props.data?.language === "EN" ? "Suggestion" : "คำแนะนำ",
                  style: "fieldKey",
                },
                {
                  margin: [5.5, 0, 0, 0],
                  ul: doctorNote,
                },
              ],
            },
          ]);

          i = i + 9;
        }
      }
      return detail || [];
    }
  };

  const contentId = () => {
    let content = [
      {
        width: "14.5%",
        text: props.data?.language === "EN" ? "Appoint No." : "เลขที่นัด",
        style: "fieldKey",
      },
      { width: "4%", text: ":", style: "fieldValue" },
      {
        width: "auto",
        text: `P01${props.data?.content_id || ""}`,
        style: "fieldValue",
      },
    ];

    if (CONFIG.SHOW_DOCTOR_CHAIR) {
      content.push({
        margin: [20, 0, 0, 0],
        image: textToBase64BarcodeBlob(`P01${props.data?.content_id || ""}`),
        width: "40",
        height: 17.5,
      });
    }

    return content;
  };
  // console.log('FormAppintmentDetail headerForm: ', headerForm);

  return {
    pageSize: "A5",
    pageOrientation: "landscape",
    defaultStyle: {
      font: font,
      lineHeight: 1,
      fontSize: 13,
    },
    ...headerForm,
    // header: {
    //   margin: [10, 5, 10, 5],
    //   stack: [
    //     {
    //       columns: [
    //         ...(!CONFIG.HIDE_COMPANY_LOGO_PRINT ? [{ margin: [0, 0, 0, 0], width: 60, image: "logo", alignment: "left" }] : [] ),
    //         {
    //           margin: [-10, 5, 0, 0],
    //           width: "*",
    //           stack: [
    //             !CONFIG.HIDE_COMPANY_LOGO_PRINT ? {
    //               text: "CHULALONGKORN UNIVERSITY, FACULTY OF DENTISTRY",
    //               style: "facultyHeader",
    //               alignment: "center",
    //             } : null,
    //             { text: "ใบนัดหมาย", style: "facultyHeader", alignment: "center" },
    //           ],
    //         },
    //       ],
    //     },
    //   ],
    // },
    content: [
      {
        table: {
          widths: ["100%"],
          body: [
            [
              {
                margin: [20, 3, 10, 3],
                stack: appointmentDetail(),
              },
            ],
            // [
            // {
            //   margin: [0, 3, 0, 3],
            //   stack: [
            //     {
            //       columns: [
            //         { width: "46.5%", text: "เอกสารและขั้นตอนการใช้สิทธิข้าราชการของผู้ป่วย", style: "miniFieldKey" },
            //         { width: "auto", text: "หมายเหตุ", style: "miniFieldKey" },
            //       ],
            //     },
            //     {
            //       columns: [
            //         { width: "46.5%", text: "สิทธิเบิกจ่ายตรง", style: "miniFieldValue" },
            //         { width: "auto", text: "ปัญหาที่เกิดขึ้นเกี่ยวกับสิทธิราชการคือ", style: "miniFieldValue" },
            //       ],
            //     },
            //     {
            //       columns: [
            //         {
            //           // to treat a paragraph as a bulleted list, set an array of items under the ul key
            //           width: "46.5%",
            //           margin: [2.5, 0, 0, 0],
            //           ul: [
            //             {
            //               stack: [
            //                 { text: "ผู้ป่วยใหม่-เก่า ติดต่อประชาสัมพันธ์เพื่อแจ้งสิทธิ", style: "miniFieldValue" },
            //                 { text: "พร้อมบัตรประชาชนก่อนพบทันตแพทย์", style: "miniFieldValue" },
            //               ],
            //             },
            //             { text: "ผู้ป่วยใหม่-เก่า นำบัตรประชาชนมาด้วยทุกครั้งที่ต้องชำระเงิน", style: "miniFieldValue" },
            //           ],
            //         },
            //         {
            //           width: "auto",
            //           margin: [2.5, 0, 0, 0],
            //           ul: [
            //             { text: "สิทธิหมดอายุ", style: "miniFieldValue" },
            //             { text: "สิทธิถูกยกเลิก", style: "miniFieldValue" },
            //             { text: "บัตรประชาชนหมดอายุ", style: "miniFieldValue" },
            //             { text: "ผู้ป่วยลืมบัตรประชาชน", style: "miniFieldValue" },
            //           ],
            //         },
            //       ],
            //     },
            //   ],
            // },
            //   {
            //     margin: [20, 3, 0, 3],
            //     stack: [
            //       { text: "คำแนะนำ", style: "fieldKey" },
            //       {
            //         margin: [5.5, 0, 0, 0],
            //         ul: (props.data.doctor_note || []).map((note: string) => ({
            //           text: note,
            //           style: "miniFieldValue",
            //         })),
            //       },
            //     ],
            //   },
            // ],
          ],
        },
      },
    ],
    footer: {
      columns: [
        ...(CONFIG.HIDE_APPOINTMENT_BARCODE
          ? [
              {
                margin: [20, 2.5, 0, 0],
                text: [
                  {
                    text: `${
                      props.data?.language === "EN" ? "Print Date-time" : "วัน-เวลาที่พิมพ์"
                    } ${formatDate(moment())} `,
                    style: "miniFieldValue",
                  },
                  { text: moment().format("HH:mm"), style: "miniFieldValue" },
                  {
                    text: `${
                      props.data?.language === "EN"
                        ? `Scheduled by ${props.data?.staffEN || ""}`
                        : `ผู้ทำนัดหมาย ${props.data?.staff || ""}`
                    }`,
                    style: "miniFieldValue",
                  },
                ],
              },
            ]
          : [
              {
                width: 80,
                margin: [20, 12.5, 0, 0],
                stack: [
                  {
                    image: textToBase64BarcodeBlob(props.data?.patient_hn),
                    width: 80,
                    height: 35,
                  },
                  {
                    margin: [20, -2.5, 0, 0],
                    text: "HN",
                    style: "fieldValue",
                    alignment: "center",
                    bold: true,
                  },
                ],
              },
              {
                width: "40%",
                margin: [40, 12.5, 0, 0],
                stack: [
                  {
                    text: [
                      {
                        text: `${
                          props.data?.language === "EN" ? "Print Date-time" : "วัน-เวลาที่พิมพ์"
                        } ${
                          props.data?.language === "EN"
                            ? moment().format("DD/MM/YYYY")
                            : formatDate(moment())
                        } `,
                        style: "miniFieldValue",
                      },
                      { text: moment().format("HH:mm"), style: "miniFieldValue" },
                    ],
                  },
                  {
                    text: `${
                      props.data?.language === "EN"
                        ? `Scheduled by ${props.data?.staffEN || ""}`
                        : `ผู้ทำนัดหมาย ${props.data?.staff || ""}`
                    }`,
                    style: "miniFieldValue",
                  },
                ],
              },
              { width: "*", text: "" },
              {
                width: "*",
                margin: [0, 2.5, 20, 20],
                alignment: "center",
                columns: divisionQR.image
                  ? [
                      {
                        margin: [0, 15, 0, 0],
                        text:
                          props.data?.language === "EN"
                            ? "QR code \nfor contact"
                            : "QR code \nติดต่อ",
                      },
                      {
                        image: divisionQR.image,
                        height: 60,
                        width: 60,
                      },
                    ]
                  : [],
              },
            ]),
        // {
        //   width: "*",
        //   margin: [40, 21, 0, 0],
        //   stack: [
        //     { text: "เลื่อนนัดกรุณาติดต่อในวันและเวลาราชการเท่านั้น", style: "miniFieldValue" },
        //     {
        //       text: "สอบถามค่ารักษาพยาบาล, นัดหมาย, ตอบแบบสอบถาม ถามทางไลน์",
        //       style: "miniFieldValue",
        //     },
        //   ],
        // },
        // {
        //   margin: [-50, -4, 0, 0],
        //   width: 40,
        //   stack: [
        //     { text: "ไลน์นัดหมาย", style: "miniFieldValue", alignment: "center" },
        //     {
        //       margin: [28, -5, 0, 0],
        //       image: "qrcode_line",
        //       width: 32.5,
        //       height: 32.5,
        //     },
        //   ],
        // },
      ],
    },
    images: {
      ...images,
      qrcode_line: origin + "/static/images/qrcode_appointment_line.png",
      // ...(props.data.divisionQR && { qrcodeDivision: props.data.divisionQR }),
    },
  };
};

export default FormAppointmentDetail;
